module.exports = __webpack_public_path__ + "static/media/sandwich.dfde5530.webp";